<template>
    <v-container>
        <template>
            <v-progress-linear v-if="loading" indeterminate ></v-progress-linear>
            <style>
                @media print 
                {
                @page {
                width: 100mm;
                height: 150mm;
                margin-left: 2mm;
                margin-right: 2mm;
                margin-top: 2mm;
                }
                .do-not-print {
                display:none;
                }
                }
            </style>
            <Barcode 
                :value="barcode" 
                :specimen="currentSpecimen" 
                :specimenVenom="currentSpecimenVenom"
                :venomTypes="allVenomTypes"
                :loading="loading">
            </Barcode>
            <div class="do-not-print">
                <v-btn
                    @click="printAgain" 
                    :loading="loading" >Print Again</v-btn>
                <v-btn
                    @click="closeWindow">Close</v-btn>
            </div>
        </template>
    </v-container>
</template>

<script>
import Barcode from "../common/BarCode";
import { mapState, Vue } from 'vuex';
import * as SpecimenAPI from "@/services/specimenAPI"

export default {
    components: {
        Barcode
    },
    props: {
        barcode: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            currentSpecimen: {},
            currentSpecimenVenom: [],
            loadingVenom: false,
        };
    },
    computed: {
        ...mapState("specimenStore", {
            loadingSpecimen: state => state.loading,
        }),
        ...mapState("venomTypeStore", {
            allVenomTypes: state => state.venomTypes,
        }),
        loading() {
            return this.loadingSpecimen || this.loadingVenom
        }
    },
    methods: {
        closeWindow() {
            window.close();
        },
        printAgain() {
            window.print();
        },
        loadSpecimen() {
            this.currentSpecimen = {};

            let that = this;
            this.$store.dispatch("specimenStore/loadSpecimens", {
                params: {
                    SpecimenDisplayID: this.barcode
                },
                success: (data) => {
                    that.currentSpecimen = data.Specimens[0];

                    if(data.Specimens[0] != undefined){
                        that.loadSpecimenVenom();
                    }
                }
            });            
        },
        loadSpecimenVenom() {
            this.loadingVenom = true;
            
            SpecimenAPI.getSpecimenVenomTypes({SpecimenID: this.currentSpecimen.SpecimenID}).then(result => {
                this.currentSpecimenVenom = result;

            })
            .catch(() => {
                // console.log('specimin venom default to empty ')
                this.currentSpecimenVenom = []
            })
            .finally(() => {
                // console.log(this.editedSpecimen)
                this.loadingVenom = false;
            });
        }
    },
    created() {
        
        this.$store.dispatch("venomTypeStore/loadVenomTypes");
        this.loadSpecimen();
    },
    watch: {
        loading: {
            handler(newVal, oldVal) {
                if (oldVal && !newVal) {
                    // we changed from loading to not loading (the load finished)

                    this.$nextTick(() => {
                        this.printAgain();
                    });
                }
            },
            deep: true
        }
    },
};
</script>
